import React from 'react';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import MetricCard from '../MetricCard';
import PieChart from '../../Reports/templates/PieChart';
import { getMetricDataFromArray } from '../../Metrics/utils';
import { MetricUId } from '../../Metrics/constants';
import getChartConfig from './utils';
import i18n from '../../../../utils/ChrI18n';
import { exportEventName } from '.';
import ChrComparison from '../../Reports/templates/ChrComparison';

const Body = (props) => {
  const { metrics } = props;
  const cardMetric = getMetricDataFromArray(metrics, MetricUId.PENDING_PROGRAM_INVITATIONS);
  const previousPeriod = cardMetric.data.previousPeriod;

  return (
    <WidgetBodyWrapper { ...props } additionalClassNames="custom-max-height-550-px" >
      <div className='d-flex flex-column'>
        <div>
          <MetricCard
            value={ cardMetric.data.value }
            title={ cardMetric.longName }
            url={ cardMetric.url }
            alert={ cardMetric.data.alert }
            eventDetails={ cardMetric.eventDetails }
            subtitle={ previousPeriod && <ChrComparison
              changeSentiment={ previousPeriod.insights.sentiment }
              changeValue={ previousPeriod.insights.changeValue }
              changeDirection={ previousPeriod.insights.direction }
              periodOne={ { dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value: cardMetric.data.value } }
              periodTwo={ { dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value } }
            /> }
          />
        </div>
        <div className="cui-widget-pie-chart pr-5">
          <PieChart
            chartOptions={ getChartConfig({ metrics }) }
            configs={ { export: true, exportEventName } }
          />
        </div>
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;
